import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a935bc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "phase-total-label" }
const _hoisted_2 = { class: "phase-total-text no-mb" }

import { computed } from 'vue'
import { modularStore } from '@/stores/v2/modular'
import { subtotalStore } from '@/stores/v2/subtotal'
import { LoadingOutlined } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WoononPhaseTotal',
  props: {
    phase: null,
    phaseLabel: null
  },
  setup(__props: any) {

const props = __props as { phase:string, phaseLabel:string };


const subtotalText = computed(() => {
  const subtotals = subtotalStore().subtotals
  return subtotals && subtotals[props.phase] ? subtotals[props.phase].subtotal_text : ''
})

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    class: _normalizeClass(["phase-total", _unref(modularStore)().phaseClosed ? 'no-mb' : ''])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, "Totaal " + _toDisplayString(__props.phaseLabel) + ":", 1),
          _createElementVNode("p", _hoisted_2, [
            (!_unref(subtotalStore)().loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(subtotalText)), 1)
                ], 64))
              : (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 1 }))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})